// extracted by mini-css-extract-plugin
module.exports = {"campus_container":"video_campus_container__OfweZ","campus_inner":"video_campus_inner__1RGlq","youtube_frame":"video_youtube_frame__YKAbU"};